import {baseState, baseMutations, baseActions} from '@/store/baseInfowindow';
import {getCompPresentation} from '@/services/ContentPresentation';

const compTypes = ['Active Lease Deal', 'Lease', 'Land Sale', 'Building Sale', 'Utility', 'Capital'];

const compButtons = compTypes.map((type) => {
  const cfg = getCompPresentation(type);
  return {
    name: cfg.getShortName(),
    type: cfg.getType(),
  };
});

const orderedCompTypes = {
  default: [
    {type: 'Active Lease Deal', label: 'Lease Deals'},
    {type: 'Lease', label: 'Leases'},
    {type: 'Land Sale', label: 'Land Sales'},
    {type: 'Building Sale', label: 'Building Sales'},
    {type: 'Utilities', label: 'Utilities'},
    {type: 'Capital', label: 'Capital'},
    {type: 'Compliance Requirements', label: 'Compliance Requirements', defaultCollapsed: true},
    {type: 'Zoning', label: 'Zoning'},
  ],
  // Move Active Lease Deal under Utilities for data center projects
  dataCenterProject: [
    {type: 'Lease', label: 'Leases'},
    {type: 'Land Sale', label: 'Land Sales'},
    {type: 'Building Sale', label: 'Building Sales'},
    {type: 'Utilities', label: 'Utilities'},
    {type: 'Active Lease Deal', label: 'Lease Deals', defaultCollapsed: true},
    {type: 'Capital', label: 'Capital'},
    {type: 'Compliance Requirements', label: 'Compliance Requirements', defaultCollapsed: true},
    {type: 'Zoning', label: 'Zoning'},
  ],
};

const state = Object.assign(baseState, {
  shouldAddCompStandardFields: false,
  compButtonFontSize: '13px',
  compButtons,
  showIcon: false,
  orderedCompTypes,
});

export default {
  namespaced: true,
  state: () => state,
  mutations: baseMutations,
  actions: baseActions,
};
